import { useAppDispatch } from 'src/hooks';
import { useEffect, useRef, useState } from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import './table-columns.scss';
import _ from 'lodash';
import {  Header } from '../../types/generic-table.model';
import { handleDropdownInputValueChange } from '../../../common/features/table/store/table-slice';
import { alphanumericSort2 } from '../../../innovation/utils/utils';

export default function SelectInputBox({
  row,
  columnMetadata,
  uniqueIDColumns,
  inputsDisabled = false,
  filteredOptions,
}: {
  row: any;
  columnMetadata: Header;
  uniqueIDColumns: Header[];
  inputsDisabled: boolean;
  filteredOptions?: any;
}) {
  const appDispatch = useAppDispatch();
  const [value, setValue] = useState(
    row.original[columnMetadata.parent.parent_field]
  );
  const previousValueRef = useRef<number>();
  const previousValue = previousValueRef.current;
  // When value is changed externally
  if (
    row.original[columnMetadata.parent.parent_field] !== previousValue &&
    row.original[columnMetadata.parent.parent_field] !== value
  ) {
    setValue(row.original[columnMetadata.parent.parent_field]);
  }

  const handleValueChange = (e) => {
    const rowIndices: number[] = [];
    let currentRow = row;
    let parentRow = currentRow.getParentRow();
    while (!_.isEmpty(parentRow)) {
      rowIndices.unshift(currentRow.index);
      currentRow = parentRow;
      parentRow = currentRow.getParentRow();
    }
    setValue(Number(e.target.value));
    appDispatch(
      handleDropdownInputValueChange({
        columnMetadata,
        uniqueIDColumns,
        rowIndices: rowIndices.reverse(),
        newValue: e.target.value,
        dataRow: row.original,
        isRowCanExpand: row.getCanExpand(),
        depth: row.depth
      })
    );
  };
  useEffect(() => {
    previousValueRef.current = row.original[
      columnMetadata.parent.parent_field
    ] as number;
  });
  if (value === undefined) {
    return <div>-</div>;
  }
  return (
    <FormControl sx={{ m: 1, minWidth: 120 }}>
      <Select
        value={value.toString()}
        onChange={handleValueChange}
        disabled={inputsDisabled}
        displayEmpty
        style={{
          width: '120px',
          height: '30px',
          border: '1px solid transparent',
          textAlign: 'left',
          fontSize: '12px'
        }}
        inputProps={{ 'aria-label': 'Without label' }}
      >
        {columnMetadata.parent.static_values &&
          columnMetadata.parent.static_values.length > 0 &&
          alphanumericSort2(filteredOptions?.length > 0 ? filteredOptions : columnMetadata.parent.static_values).map(
            (option, i) => (
              // eslint-disable arrow-body-style
              <MenuItem
                key={option.value}
                value={option.value}
                style={{ fontSize: '12px' }}
              >
                {option.alias}
              </MenuItem>
            )
          )}
      </Select>
    </FormControl>
  );
}
